import React from "react";
import "../css/EscortPassengers.css";

const EscortPassengersList = ({ passengers }) => {
  const filteredPassengers = passengers?.filter(
    (passenger) => passenger.requiresEscortService
  );

  return (
    <div className="escort-passengers-list" data-testid="escort-passengers-list">
      <p>Passengers</p>
      {filteredPassengers?.length > 0 ? (
        filteredPassengers?.map((passenger, index) => (
          <div key={index} className="escort-passenger">
            <p>
              {index + 1}. {passenger.fullName}
            </p>
            <span>Special Onboarding</span>
          </div>
        ))
      ) : (
        <p>No passengers require Special Onboarding.</p>
      )}
    </div>
  );
};

export default EscortPassengersList;
